module.exports = __webpack_public_path__ + "img/logo-name-white.f3c6cd5c.png";